import { CMSLink, CMSRecord } from "./types";

export const getRecordLink = (path: string, record: CMSRecord | CMSLink) => path.replace(":record_type", record.record_type).replace(":id", record._id.toString())